import { render, staticRenderFns } from "./tzlxgzb.vue?vue&type=template&id=205e5804&scoped=true&"
import script from "./tzlxgzb.vue?vue&type=script&lang=js&"
export * from "./tzlxgzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e5804",
  null
  
)

export default component.exports